export default __webpack_public_path__ + "static/media/e-learning.eeb2df50.png";